import axios from 'axios'
import InsuranceOptionsTransformer from 'transformers/InsuranceOptionsTransformer'
import InsuranceAlphabetTransformer from 'transformers/InsuranceAlphabetTransformer'

export default {
    getList() {
        return axios.get('unauthenticated/insurance-plan-groups?_fields=id,name,insurancePlans(id,name)', {
            transformResponse: [InsuranceOptionsTransformer.transform('id', 'name')],
        })
    },

    getListTransformByLetter() {
        return axios.get('unauthenticated/insurance-plan-groups?_fields=id,name,insurancePlans(id,name)', {
            transformResponse: [InsuranceAlphabetTransformer.transform()],
        })
    },
}
